export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8401.43c0af54.jpg";